module.exports = __webpack_public_path__ + "95aa02c7d7b11099305f98b3b59a9fa1.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_customer_service.svg
// module id = ./images/space_customer_service.svg
// module chunks = 5